<template>
  <div class="mt-5">
    <div
      class="mb-3"
      v-for="(variant, variantKey) in variants"
      :key="`variant-key-${variantKey}`"
    >
      <div class="group">
        <h5>{{ "answer_ponint" | setText("Пункт") }} {{ variantKey + 1 }}</h5>

        <div class="mt-3">
          <button
            @click="removeAnswer(variantKey)"
            class="btn btn-danger btn-sm"
          >
            <span class="ti-close" />
          </button>
        </div>
        <div class="mt-3">
          <select class="form-control mb-2" v-model="variant.type">
            <option :value="'simple'">Обычный текст</option>
            <option :value="'answer'">Пропущенное слово</option>
          </select>

          <RichEditor
            v-if="variant.type === 'simple'"
            v-model="variant.value"
            :options="$store.state.editorOption"
          />

          <input
            v-model="variant.value"
            class="form-control"
            v-else-if="variant.type === 'answer'"
          />
        </div>
      </div>
    </div>

    <button @click="addVariant()" class="btn btn-sm my-4 add-point-button">
      {{ "Добавить пункт" }}
    </button>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import RichEditor from "@/components/Editor/RichTextEditor.vue";

export default {
  name: "Dropdown",
  components: { draggable, RichEditor },

  props: {
    value: Array,
  },

  data() {
    return {
      variants: [],
    };
  },
  created() {
    this.variants = this.value;
  },
  methods: {
    addVariant() {
      this.variants.push({ value: "", type: "answer" });
      setTimeout(() => {
        this.$emit("input", this.variants);
      }, 1);
    },
    removeAnswer(index) {
      this.variants.splice(index, 1);

      setTimeout(() => {
        this.$emit("input", this.variants);
      }, 1);
    },
  },
};
</script>
